import {
    MonoTypeOperatorFunction,
    Observable,
    ReplaySubject,
    timer,
} from 'rxjs';
import { share, tap } from 'rxjs/operators';

export function shareTimedReplay<T>(
    bufferSize: number = 1,
    windowTime: number = Infinity
): MonoTypeOperatorFunction<T> {
    let subscriptionTime: number;

    return (source: Observable<T>) => {
        return source.pipe(
            tap(() => (subscriptionTime = new Date().getTime())),
            share({
                connector: () => new ReplaySubject(bufferSize),
                resetOnError: true,
                resetOnComplete: () => {
                    const currentTime = new Date().getTime();
                    const elapsedTime = currentTime - subscriptionTime;
                    return timer(Math.max(0, windowTime - elapsedTime));
                },
                resetOnRefCountZero: () => {
                    const currentTime = new Date().getTime();
                    const elapsedTime = currentTime - subscriptionTime;
                    return timer(Math.max(0, windowTime - elapsedTime));
                },
            })
        );
    };
}
